enum Paths {
    promotionCategory = '/promotion-categories',
    promotionCategoryCreate = '/promotion-categories/create',
}

export default Paths;



// WEBPACK FOOTER //
// ./src/modules/PromotionCategory/paths.ts